<app-header></app-header>
<div class="wrapper">
  <div class="container">
    <div class="row mt-4 pb-4">
      <div class="col-12 text-center">
        <h2 class="manage-profile-heading">
          {{ "ADD_PROFILE.NEW_PROFILE" | translate }}
        </h2>
        <ul class="profile-user-list manage-profile-sect mb-0">
          <li>
            <a
              href="javascript:void(0)"
              class="manage-profile icon-bg-{{ model.color }}"
            >
              <img src="assets/images/user-icon.png" class="w-100" />
            </a>
          </li>
        </ul>
        <form
          class="manage-profile-from"
          (ngSubmit)="onSubmit(profileForm)"
          #profileForm="ngForm"
        >
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Enter Name"
              [(ngModel)]="model.name"
              #name="ngModel"
              name="name"
              required
            />
            <div
              style="color: red"
              class="validation_div"
              *ngIf="name.errors && (name.dirty || profileForm.submitted)"
            >
              <p class="mb-0" *ngIf="name.errors.required">Name required</p>
              <!-- <p class="mb-0" *ngIf="email.errors.pattern">
                        {{ "LOGIN_INFO.EMAIL_PATTERN" | translate }}
                      </p> -->
            </div>
          </div>
          <div class="d-flex text-left pt-3 mb-4">
            <div>
              <p class="mb-0">{{ "ADD_PROFILE.KIDS_PROFILE" | translate }}</p>
              <span class="text-secondary">
                {{ "ADD_PROFILE.MESSAGE" | translate }}
              </span>
              <!-- <a href="javascript:void(0)" class="orange-link">
                {{ "ADD_PROFILE.LEARN_MORE" | translate }}
              </a> -->
            </div>
            <mat-slide-toggle (change)="onChange($event)"></mat-slide-toggle>
          </div>
          <div class="pt-3">
            <button
              class="btn btn-cancel mr-3"
              type="button"
              [routerLink]="['/manage-profile/watch']"
            >
              {{ "ADD_PROFILE.CANCEL" | translate }}
            </button>
            <button [disabled]="btnDisable" class="btn btn-theme" type="submit">
              <span class="spin icon-loader" *ngIf="isLoading"> </span>
              {{ "ADD_PROFILE.SAVE_CHANGES" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
